    <div class="signinComponent" [ngClass]="loginState">

      <fieldset class="fieldset withoutM">
        <legend class="legend">{{"phone" | translate}}</legend>
        <input id="signinPhoneInput" [(ngModel)]="loginForm.phone" name="phoneUser" inputmode="numeric" class="app-input" placeholder="+{{dialCode}} XXXX XXXX" (input)="onPhoneInput($event)"
          maxlength="{{ userPhoneAllowedDigit }}" />
      </fieldset>

      <div class="stagBar">
        <fieldset class="fieldset">
          <legend class="legend">{{"Password" | translate}}</legend>
          <input id="signinPasswordInput" [(ngModel)]="loginForm.password" name="password" [type]="passwordInputType" class="app-input" placeholder="{{ 'enter_your_password' | translate }}" />
          <ion-icon (click)="togglePasswordVisibility()" class="eye-pwd" [src]="!showPasswordFlag ? '../../../../assets/svg/eye-off.svg' : '../../assets/svg/eye.svg'"></ion-icon>
        </fieldset>
        <ion-icon class="passForget" src="assets/svg/question.svg" (click)="resetPassword()"></ion-icon>
      </div>

      <div class="btnBar">
        <app-button class="btnSmall" [borderRad]="'30'" [color]="'secondary'" [opacity]="[9,8,9]" [height]="'5vh'" [width]="'30'" (buttonClick)="manualBiometricLogin()">
          <ion-icon class="btnIconInner inverted" src='/assets/svg/biopass.svg'></ion-icon>
        </app-button>

        <app-button [disabled]="!loginForm.phone || !loginForm.password" class="btnBig" [height]="'5vh'" [width]="'70'" [borderRad]="'30'" (buttonClick)="onSubmitLogin()" [color]="'primary'" [opacity]="[9,9,10]">
          {{'signin' | translate}}
        </app-button>
      </div>

    </div>

    <div class="popLoadingBack" *ngIf="loading">
    <div class="popLoading">

        <div class="popLoader">
          <div class="loader"></div>
    </div>
</div>


<!-- 
 openModal() {
    this.newCustomer = true;
  }

  // This method now just toggles the boolean
  closeModal() {
    this.newCustomer = false;
  } -->